import React from 'react'

const Businesses = React.lazy(() => import('pages/Business/Business'));
const BusinessAdd = React.lazy(() => import('pages/Business/BusinessAdd'));
const BusinessDetail = React.lazy(() => import('pages/Business/BusinessDetail'));
const BusinessEdit = React.lazy(() => import('pages/Business/BusinessEdit'));


const BusinessRoutes = [
    {
        path: '/businesses',
        exact: true,
        name: 'Danh sách cơ sở',
        function: 'AM_BUSINESS_VIEW',
        component: Businesses,
    },
    {
        path: '/businesses/add',
        exact: true,
        name: 'Thêm mới',
        function: 'AM_BUSINESS_ADD',
        component: BusinessAdd,
    },
    {
        path: '/businesses/detail/:id',
        exact: true,
        name: 'Chi tiết',
        function: 'AM_BUSINESS_VIEW',
        component: BusinessDetail,
    },
    {
        path: '/businesses/edit/:id',
        exact: true,
        name: 'Chỉnh sửa',
        function: 'AM_BUSINESS_EDIT',
        component: BusinessEdit,
    },
]

export default BusinessRoutes
